"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelected = void 0;
var _react = require("react");
const emptyArray = [];
const useSelected = function () {
  let selectedGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyArray;
  let selectedStudents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyArray;
  let classesMapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let groupsMapper = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  let studentsMapper = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  let onChanged = arguments.length > 5 ? arguments[5] : undefined;
  const [selectedGroupsIds, setSelectedGroupsIds] = (0, _react.useState)([]);
  const [selectedClassesIds, setSelectedClassesIds] = (0, _react.useState)([]);
  const [selectedStudentsIds, setSelectedStudentsIds] = (0, _react.useState)([]);
  const [originalSelectedGroupsIds, setOriginalSelectedGroupsIds] = (0, _react.useState)([]);
  const [originalSelectedClassesIds, setOriginalSelectedClassesIds] = (0, _react.useState)([]);
  const [originalSelectedStudentsIds, setOriginalSelectedStudentsIds] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    if (selectedGroups) {
      const selectedClassesIds = selectedGroups.filter(group => group.groupType === 'class').map(group => group.id);
      setOriginalSelectedClassesIds(selectedClassesIds);
      setSelectedClassesIds(selectedClassesIds);
      const selectedGroupsIds = selectedGroups.filter(group => group.groupType === 'subschool').map(group => group.id);
      setOriginalSelectedGroupsIds(selectedGroupsIds);
      setSelectedGroupsIds(selectedGroupsIds);
    } else {
      setOriginalSelectedClassesIds([]);
      setSelectedClassesIds([]);
      setOriginalSelectedGroupsIds([]);
      setSelectedGroupsIds([]);
    }
  }, [selectedGroups]);
  (0, _react.useEffect)(() => {
    if (selectedStudents) {
      const selectedStudentesIds = selectedStudents.map(student => student.id || student.studentID);
      setSelectedStudentsIds(selectedStudentesIds);
      setOriginalSelectedStudentsIds(selectedStudentesIds);
    } else {
      setOriginalSelectedStudentsIds([]);
      setSelectedStudentsIds([]);
    }
  }, [selectedStudents]);
  const getSelectedGroupsAndStudentsData = () => {
    return {
      selectedGroups: [...selectedClassesIds?.map(c => classesMapper && classesMapper[c]),
      //.filter((c: string) => !!c),
      ...selectedGroupsIds?.map(g => groupsMapper && groupsMapper[g]) //.filter((g: string) => !!g),
      ],
      selectedStudents: selectedStudentsIds?.map(s => studentsMapper && studentsMapper[s]) //.filter((s: string) => !!s),
    };
  };
  const onSelectedChanged = newSelectedData => {
    setSelectedGroupsIds(newSelectedData.selectedGroupsIds);
    setSelectedClassesIds(newSelectedData.selectedClassesIds);
    setSelectedStudentsIds(newSelectedData.selectedStudentsIds);
    if (onChanged) {
      onChanged({
        selectedGroups: [...newSelectedData.selectedClassesIds?.map(c => classesMapper && classesMapper[c]),
        //.filter((c) => !!c),
        ...newSelectedData.selectedGroupsIds?.map(g => groupsMapper && groupsMapper[g]) //.filter((g) => !!g),
        ],
        selectedStudents: newSelectedData.selectedStudentsIds?.map(s => studentsMapper && studentsMapper[s]) //.filter((s) => !!s),
      });
    }
  };
  return {
    setSelectedGroupsIds,
    selectedGroupsIds,
    selectedClassesIds,
    originalSelectedGroupsIds,
    originalSelectedClassesIds,
    setSelectedStudentsIds,
    selectedStudentsIds,
    originalSelectedStudentsIds,
    getSelectedGroupsAndStudentsData,
    onSelectedChanged
  };
};
exports.useSelected = useSelected;